/* import __COLOCATED_TEMPLATE__ from './blade-attachments.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();